import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Stateless function representing a tire shape with 4 curve lines.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TireShapeWarningIllustration className={'warning-shape'}/>
 */

const defaultProps = {
    viewBox: '0 0 12 32',
    keepPathColor: true
}

const TireShapeWarningIllustration = props => (
    <SvgIcon {...props}>
        <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" rx="3" />
        <path
            fill="#b5b9bc"
            d="M9.6,0H2.4C1.1,0,0,1.1,0,2.4v27.2C0,30.9,1.1,32,2.4,32h7.2c1.3,0,2.4-1.1,2.4-2.4V2.4C12,1.1,10.9,0,9.6,0z
            M9.6,26.3l-2.2,2.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1l-1.9-1.9L3,28.5c-0.2,0.2-0.4,0.2-0.6,0v0
           c-0.2-0.2-0.2-0.4,0-0.6l2.2-2.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1l1.9,1.9L9,25.7c0.2-0.2,0.4-0.2,0.6,0
           S9.8,26.1,9.6,26.3z M9.6,23.2l-2.2,2.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1l-1.9-1.9L3,25.4c-0.2,0.2-0.4,0.2-0.6,0v0
           c-0.2-0.2-0.2-0.4,0-0.6l2.2-2.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1l1.9,1.9L9,22.6c0.2-0.2,0.4-0.2,0.6,0
           S9.8,23,9.6,23.2z M9.6,20.1l-2.2,2.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1l-1.9-1.9L3,22.3c-0.2,0.2-0.4,0.2-0.6,0v0
           c-0.2-0.2-0.2-0.4,0-0.6l2.2-2.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1l1.9,1.9L9,19.5c0.2-0.2,0.4-0.2,0.6,0
           S9.8,20,9.6,20.1z M9.6,17.1l-2.2,2.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1l-1.9-1.9L3,19.3c-0.2,0.2-0.4,0.2-0.6,0v0
           c-0.2-0.2-0.2-0.4,0-0.6l2.2-2.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1l1.9,1.9L9,16.5c0.2-0.2,0.4-0.2,0.6,0
           S9.8,16.9,9.6,17.1z"
        />
    </SvgIcon>
)

TireShapeWarningIllustration.defaultProps = defaultProps

export { TireShapeWarningIllustration }
